import { controller, Selects, SubmitChange, FileInputs } from './form'
import {
    setupModals,
    Header,
    PageList,
    Accordions,
    gmap,
    SetupVideos,
    SetupAutoPlayVideos,
    ProgressiveHover,
    initJump,
    StickyBars,
    SmoothScroll
} from './ui'
import lazySizes from 'lazysizes'

let accordions

function init() {
    accordions = Accordions()
    sliders()
    listingSlider()
    Header()
    setupModals()
    forms()
    PageList()
    gmap()
    SetupVideos()
    SetupAutoPlayVideos()
    Selects()
    initSW()
    ProgressiveHover()
    SubmitChange()
    FileInputs()
    initJump()
    SmoothScroll()
    StickyBars(['.js-sticky-bar'])
}

if (document.readyState !== 'loading') {
    init()
} else {
    document.addEventListener('DOMContentLoaded', init)
}

function forms() {
    const forms = document.querySelectorAll('.js-form-builder')

    forms.forEach(form => {
        form.addEventListener('fbfailure', () => {
            if (accordions.length) {
                accordions
                    .filter(accordion => accordion.el.classList.contains('o-accordion__list'))
                    .map(accordion => {
                        accordion.items.forEach(item => {
                            if (item.el.querySelector('.has-error')) {
                                item.openAccordion()
                            } else {
                                item.closeAccordion()
                            }
                        })
                    })

                window.location = '#candidate-register'
            }
        })
    })

    const registerWithUsFieldset = document.querySelector('.register-with-us-options')

    if (registerWithUsFieldset != null) {
        const registerBtn = document.querySelector('#candidate-register button')

        if (registerBtn) {
            registerBtn.addEventListener('click', () => {
                const select = registerWithUsFieldset.querySelector('.c-form-builder__input-select')
                var value = select.value
                if (value == 'new') {
                    window.location.href = '/candidate/register-with-us-new'
                } else if (value == 'already') {
                    window.location.href = '/candidate/register-with-us-already-in-touch'
                }
            })
        }
    }

    const engagementBasisFieldset = document.querySelector('.engagement-basis')

    if (engagementBasisFieldset != null) {
        const radioButtons = engagementBasisFieldset.querySelectorAll("input[type='radio']")
        const temporaryOptionsDiv = engagementBasisFieldset.querySelector(
            '.c-form-builder__input.js-input:last-of-type'
        )

        temporaryOptionsDiv.style.display = 'none'

        radioButtons.forEach(function(radioButton) {
            radioButton.addEventListener('click', function() {
                if (radioButton.value === 'Temporary') {
                    temporaryOptionsDiv.style.display = 'block'
                } else if (radioButton.value === 'Permanent') {
                    temporaryOptionsDiv.style.display = 'none'
                } else if (radioButton.value === 'Not sure') {
                    temporaryOptionsDiv.style.display = 'none'
                }
            })
        })

        const haveConvictionsYes = document.querySelector(
            'div[data-name="do-you-have-any-criminal-convictions"] input[value="Yes"]'
        )
        const haveConvictionsNo = document.querySelector(
            'div[data-name="do-you-have-any-criminal-convictions"] input[value="No"]'
        )
        const convictionsFields = [
            {
                label: 'Conviction',
                name: 'conviction'
            },
            {
                label: 'Date of conviction',
                name: 'date_of_conviction'
            },
            {
                label: 'Sentence/Fine',
                name: 'sentence_fine'
            }
        ]

        // add event listener to the radio buttons
        haveConvictionsYes.addEventListener('change', updateFields)
        haveConvictionsNo.addEventListener('change', updateFields)

        function updateFields() {
            if (haveConvictionsYes.checked) {
                // update fields to required
                document.querySelectorAll('label').forEach(labelEl => {
                    const field = convictionsFields.find(field =>
                        labelEl.textContent.trim().includes(field.label)
                    )
                    if (field) {
                        const inputEl = labelEl.nextElementSibling
                        inputEl.required = true
                        labelEl.textContent = field.label
                    }
                })
            } else if (haveConvictionsNo.checked) {
                // reset fields to optional
                document.querySelectorAll('label').forEach(labelEl => {
                    const field = convictionsFields.find(field =>
                        labelEl.textContent.trim().includes(field.label)
                    )
                    if (field) {
                        const inputEl = labelEl.nextElementSibling
                        inputEl.required = false
                        labelEl.textContent = `${field.label} (Optional)`
                    }
                })
            }
        }
    }
}

function initSW() {
    if (window.location.hostname === 'localhost') {
        return
    }

    if ('serviceWorker' in navigator) {
        navigator.serviceWorker
            .getRegistrations()
            .then(function(registrations) {
                for (let registration of registrations) {
                    if (registration.active.scriptURL.includes('sw.js')) {
                        registration.unregister()
                    }
                }
            })
            .catch(function(err) {
                console.log('Service Worker registration failed: ', err)
            })
    }
}

function sliders() {
    const genericSliderEls = document.querySelectorAll('.js-slider')
    const listingSliderEls = document.querySelectorAll('.js-listing-slider')

    if (genericSliderEls.length || listingSliderEls.length) {
        import('./ui/slider')
            .then(m => m.Slider)
            .then(Slider => {
                genericSlider(Slider, genericSliderEls)
                listingSlider(Slider, listingSliderEls)
            })
    }
}

function genericSlider(Slider, els) {
    if (!els || !els.length) {
        return
    }
    const sliders = Array.from(els)
    sliders.forEach(el => {
        let { dots, slidesToShow } = el.dataset
        dots = dots !== 'false'
        slidesToShow = +slidesToShow || 1

        Slider(el, {
            options: {
                slidesToShow,
                arrows: true,
                referenceArrows: true,
                dots,
                infiniteSlide: true,
                horizontalSlide: true,
                dotFormat: () => '<span></span>'
            },
            classes: {
                slider: 'o-slider',
                viewport: 'o-slider__viewport',
                track: 'o-slider__track',
                slide: 'o-slider__slide',
                slideClone: 'o-slider__slide--clone',
                nextArrow: 'o-slider__arrow--next',
                prevArrow: 'o-slider__arrow--prev',
                dotList: 'o-slider__dots',
                dot: 'o-slider__dot'
            }
        })
    })
}

function listingSlider(Slider, els) {
    if (!els || !els.length) {
        return
    }
    const listingSliders = Array.from(els)
    listingSliders.forEach(el => {
        let { dots, slidesToShow, noMobileChange } = el.dataset
        dots = dots !== 'false'
        noMobileChange = noMobileChange === 'true'
        slidesToShow = +slidesToShow || 1

        let responsive = {}

        if (slidesToShow === 4 && !noMobileChange) {
            responsive = {
                '768px': {
                    slidesToShow: 2
                },
                '1024px': {
                    slidesToShow: 4
                }
            }

            slidesToShow = 1
        }

        if (slidesToShow === 3 && !noMobileChange) {
            responsive = {
                '1024px': {
                    slidesToShow: 3
                }
            }

            slidesToShow = 1
        }

        if (slidesToShow === 2 && !noMobileChange) {
            responsive = {
                '1024px': {
                    slidesToShow: 2
                }
            }

            slidesToShow = 1
        }

        window.slider = Slider(el, {
            options: {
                slidesToShow: slidesToShow,
                arrows: true,
                referenceArrows: true,
                dots,
                infiniteSlide: true,
                horizontalSlide: true,
                dotFormat: () => '<span></span>',
                responsive
            },
            classes: {
                slider: 'o-slider',
                viewport: 'o-slider__viewport',
                track: 'o-slider__track',
                slide: 'o-slider__slide',
                slideClone: 'o-slider__slide--clone',
                nextArrow: 'o-slider__arrow--next',
                prevArrow: 'o-slider__arrow--prev',
                dotList: 'o-slider__dots',
                dot: 'o-slider__dot'
            }
        })
    })
}
